import { ACTION } from './project_member_actions';
import { delete_reducer, list_reducer } from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  isLoading: false,
  isRemoving: false,
  totalCount: 0,
  filteredCount: 0,
  errorMessage: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        isLoading: false,
        totalCount: action.payload.recordsTotal,
        filteredCount: action.payload.recordsFiltered,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.REMOVE}_PENDING`:
      return {
        ...state,
        isRemoving: true,
        errorMessage: null,
      };
    case `${ACTION.REMOVE}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        isRemoving: false,
      };
    case `${ACTION.REMOVE}_REJECTED`:
      return {
        ...state,
        isRemoving: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/project_member/project_member_reducer.js